// BillZapp membership plans shown on the website. Copied from the POS app's
// POS-System-Backend/utils/membershipPlans.js, which is what customers are actually
// charged - update both together when prices or features change.
// amountPaise/periodDays are the monthly price; `annual` is the pay-yearly option.
// Prices include GST.
// On-sale display (website only): `wasAmountPaise` is the higher price shown struck through
// next to the real one. Customers are always charged amountPaise. The yearly "was" price is
// ₹1,999 more, and the monthly one ₹167 more (₹1,999 / 12).
// `poster` (website only) is the plan's features poster, the second photo on its product pages.
export const BILLZAPP_PLANS = [
  {
    id: 1,
    name: "Basic Plan",
    amountPaise: 35900, // INR 359
    wasAmountPaise: 52600, // INR 526
    periodDays: 30,
    annual: { amountPaise: 400000, periodDays: 365, wasAmountPaise: 599900 }, // INR 4000, was 5999
    recommended: false,
    poster: "/images/billzapp/billzapp-basic-features.jpg",
    features: [
      "Cloud billing",
      "Direct Order Management System (RET)",
      "Inventory Tracking",
      "Customer Relationship Management",
      "Simple Reporting",
      "2 Device Support",
      "24x7 Call Support",
      "2inch / 3inch Printing",
    ],
  },
  {
    id: 2,
    name: "Pro Plan",
    amountPaise: 49900, // INR 499
    wasAmountPaise: 66600, // INR 666
    periodDays: 30,
    annual: { amountPaise: 500000, periodDays: 365, wasAmountPaise: 699900 }, // INR 5000, was 6999
    recommended: true,
    poster: "/images/billzapp/billzapp-pro-features.jpg",
    features: [
      "Cloud billing",
      "Tablewise Order Management System (KOT)",
      "Inventory Tracking",
      "Customer Relationship Management",
      "Advanced Reporting",
      "Multi Device Support",
      "24x7 Priority Call Support",
      "2inch / 3inch Printing",
      "Advanced Analytics & Reports",
      "Staff Management System",
      "Custom Branding",
      "Regional Language Support",
    ],
  },
];

// The live BillZapp server, which also serves the BillZapp web app.
const LIVE_POS_URL = "https://pos.sateriservices.com";

// The BillZapp web app, where owners sign up and pay for a plan (Razorpay checkout).
// .env.development points `npm start` at a local POS app instead.
export const POS_PORTAL_URL = process.env.REACT_APP_POS_PORTAL_URL || LIVE_POS_URL;

// Free trial every new BillZapp account starts with (TRIAL_PERIOD_DAYS in the POS backend).
export const TRIAL_PERIOD_DAYS = 15;

// The BillZapp receipt printers sold in the "Pocket Billing Machine With Software" bundles: a one-time
// price on top of a year of the plan. The server charges BUNDLE_PRINTERS in
// POS-System-Backend/utils/membershipPlans.js, so change both together (`image` is website-only).
export const BILLZAPP_PRINTERS = [
  { id: "2inch", name: "2 inch", amountPaise: 350000, image: "/images/billzapp/billing-machine-2inch.png" }, // INR 3500
  { id: "3inch", name: "3 inch", amountPaise: 550000, image: "/images/billzapp/billing-machine-3inch.png" }, // INR 5500
];

// Every printer comes with either plan: 2 inch Basic, 2 inch Pro, 3 inch Basic, 3 inch Pro.
// Each bundle has its own page at /products/<slug>, e.g. /products/2inch-pro.
export const BILLZAPP_BUNDLES = BILLZAPP_PRINTERS.flatMap((printer) =>
  BILLZAPP_PLANS.map((plan) => {
    const software = plan.name.replace(/ Plan$/, "");
    return {
      slug: `${printer.id}-${software.toLowerCase()}`,
      printer,
      plan,
      software,
      title: `${printer.name} Pocket Billing Machine With ${software} Software`,
    };
  })
);

// The BillZapp server's API, which takes "Pocket Billing Machine With Software" orders and payments.
// .env.development points `npm start` at a local POS backend instead.
export const POS_API_URL = process.env.REACT_APP_POS_API_URL || `${LIVE_POS_URL}/api/v1`;
